export default __webpack_public_path__ + "static/media/pexels-mikhail-nilov-7535102.47c1498e.mp4";